import script from "./MCarregadorDeArquivos.vue?vue&type=script&setup=true&lang=ts"
export * from "./MCarregadorDeArquivos.vue?vue&type=script&setup=true&lang=ts"

import "./MCarregadorDeArquivos.vue?vue&type=style&index=0&id=6111e67a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6111e67a"]])

export default __exports__